// Cross-tab messages between open aw-user tabs (same origin) via BroadcastChannel.
// The sending tab does not receive its own message.

const ChannelName = "aw-user";
const supported =
  typeof window !== "undefined" && "BroadcastChannel" in window;
let sender = null;

export const BroadcastEvents = {
  Logout: "logout",
  Login: "login",
  UserUpdated: "user-updated",
};

// Sends an event to all other open aw-user tabs.
export const broadcast = (type, data = {}) => {
  if (!supported) return;
  sender = sender || new BroadcastChannel(ChannelName);
  sender.postMessage({ type, data });
};

// Listens for one or more event types. Returns a cleanup function for useEffect.
export const onBroadcast = (types, handler) => {
  if (!supported) return () => {};
  const list = [].concat(types);
  const channel = new BroadcastChannel(ChannelName);
  channel.onmessage = (e) => {
    if (list.includes(e.data?.type)) handler(e.data);
  };
  return () => channel.close();
};
